/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonWithRoleResponse
 */
export interface PersonWithRoleResponse {
    /**
     * Person with role UUID
     * @type {string}
     * @memberof PersonWithRoleResponse
     */
    uuid?: string;
    /**
     * Firstname of the person
     * @type {string}
     * @memberof PersonWithRoleResponse
     */
    firstname?: string;
    /**
     * Lastname of the person
     * @type {string}
     * @memberof PersonWithRoleResponse
     */
    lastname?: string;
    /**
     * Phone number of the person
     * @type {string}
     * @memberof PersonWithRoleResponse
     */
    phoneNumber?: string;
    /**
     * Email of the person
     * @type {string}
     * @memberof PersonWithRoleResponse
     */
    email?: string;
}

/**
 * Check if a given object implements the PersonWithRoleResponse interface.
 */
export function instanceOfPersonWithRoleResponse(value: object): value is PersonWithRoleResponse {
    return true;
}

export function PersonWithRoleResponseFromJSON(json: any): PersonWithRoleResponse {
    return PersonWithRoleResponseFromJSONTyped(json, false);
}

export function PersonWithRoleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonWithRoleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function PersonWithRoleResponseToJSON(json: any): PersonWithRoleResponse {
    return PersonWithRoleResponseToJSONTyped(json, false);
}

export function PersonWithRoleResponseToJSONTyped(value?: PersonWithRoleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'phoneNumber': value['phoneNumber'],
        'email': value['email'],
    };
}

